import React from 'react';
import { Chip, Tooltip } from '@material-ui/core';
import {
  STATUS_AS_CONFIG,
  STATUS_AS_DEFAULT_CONFIG,
  STATUS_AS_TOOLTIP,
} from './statusIntegracaoASBadge.constants';

export default function StatusIntegracaoASBadge({ status }) {
  const config = STATUS_AS_CONFIG[status] ?? STATUS_AS_DEFAULT_CONFIG;

  return (
    <Tooltip title={STATUS_AS_TOOLTIP}>
      <Chip
        label={config.label}
        size="small"
        style={{
          backgroundColor: config.color,
          color: '#fff',
          fontWeight: 'bold',
          marginBottom: '8px',
        }}
      />
    </Tooltip>
  );
}
